import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { EnvService } from "src/app/env.service";
import { UserService } from "../services/user.service";

@Injectable()
export class BackendUrlInterceptor implements HttpInterceptor {
  private isIE = detectIE();
  alreadyRefreshingToken = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private env: EnvService,
    private store: Store
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url &&
      (req.url.indexOf("assets") !== -1 || req.url.indexOf("/player/") !== -1)
    ) {
      return next.handle(req);
    }

    let token = sessionStorage.getItem(this.env.jwt);
    const citoModule = this.store.selectSnapshot<number>(
      (state: any) => state.dashboard.module
    );

    this.userService.isTokenExpired().then((isExpired: boolean) => {
      if (isExpired) {
        this.router.navigate(["/login"]);
        req = this.applyHeaders(req, token, citoModule);
        return next.handle(req);
      }
    });

    var almostExpired = this.userService.isTokenAlmostExpired();
    if (
      req.url &&
      req.url.indexOf("command-api/User/LogAction") !== 1 &&
      almostExpired &&
      !this.alreadyRefreshingToken
    ) {
      this.alreadyRefreshingToken = true;
      this.userService.getNewToken().subscribe((result) => {
        token = result.jwt;

        this.alreadyRefreshingToken = false;
      });
    }

    req = this.applyHeaders(req, token, citoModule);
    return next.handle(req);
  }

  private applyHeaders(req: HttpRequest<any>, token: string, module: number) {
    return req.clone({
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        Module: `${module}`,
      }),
      withCredentials: true,
      url: !this.isIE
        ? this.env.apibase + req.url
        : `${this.env.apibase}${req.url}?${new Date().getTime()}`,
    });
  }
}

function detectIE(): boolean {
  const ua = window.navigator.userAgent;
  return (
    ua.indexOf("MSIE ") > 0 ||
    ua.indexOf("Trident/") > 0 ||
    ua.indexOf("Edge/") > 0
  );
}
